import bannerStrand from '../../assets/images/Banner_Strand.png'
import usaFlag from '../../assets/images/usa-flag.svg'

export const returnGoodsPolicyContent = {
    "sys": {
      "type": "Array"
    },
    "total": 1,
    "skip": 0,
    "limit": 100,
    "items": [
      {
        "fields": {
          "name": "Return Goods Policy Content Page",
          "title": "Return Goods Policy",
          "slug": "return-goods-policy",
          "seo": {
            "metadata": {
              "tags": [],
              "concepts": []
            },
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "n9bebhw263o0"
                }
              },
              "id": "5gMYYleewpKSWJ4q6TvZUj",
              "type": "Entry",
              "createdAt": "2022-12-14T23:01:59.639Z",
              "updatedAt": "2022-12-14T23:01:59.639Z",
              "environment": {
                "sys": {
                  "id": "sandbox",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "publishedVersion": 11,
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "seo"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "name": "Return Goods Policy Content Page - Compose: SEO"
            }
          },
          "content": {
            "metadata": {
              "tags": [],
              "concepts": []
            },
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "n9bebhw263o0"
                }
              },
              "id": "4gWDVRE6oKE0h0dqd37xcu",
              "type": "Entry",
              "createdAt": "2022-12-14T23:01:59.660Z",
              "updatedAt": "2023-06-20T16:21:22.755Z",
              "environment": {
                "sys": {
                  "id": "sandbox",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "publishedVersion": 21,
              "revision": 5,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "richTextContentPageTemplate"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "name": "Return Goods Policy Content Page - Rich Text Content Page Template",
              "modules": [
                {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "4yWyEpVfxgjAmUcWCWMXBe",
                    "type": "Entry",
                    "createdAt": "2022-12-14T23:04:20.745Z",
                    "updatedAt": "2023-06-16T18:23:22.281Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 20,
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "bannerComponent"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Return Goods Policy Banner Component",
                    "headline": "Moderna Vaccine Product Return Policy",
                    "backgroundImage": {
                      "metadata": {
                        "tags": [],
                        "concepts": []
                      },
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "n9bebhw263o0"
                          }
                        },
                        "id": "5zfGJA7or5WGcLdYi4Qde",
                        "type": "Asset",
                        "createdAt": "2022-10-28T18:53:29.208Z",
                        "updatedAt": "2022-10-28T18:53:29.208Z",
                        "environment": {
                          "sys": {
                            "id": "sandbox",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "publishedVersion": 6,
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Banner BG Strand Top",
                        "description": "",
                        "file": {
                          "url": bannerStrand,
                          "details": {
                            "size": 47693,
                            "image": {
                              "width": 1920,
                              "height": 511
                            }
                          },
                          "fileName": "Banner BG Strand Top .png",
                          "contentType": "image/png"
                        }
                      }
                    },
                    "country": {
                      "metadata": {
                        "tags": [],
                        "concepts": []
                      },
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "n9bebhw263o0"
                          }
                        },
                        "id": "7sht7920U6vs3CLH2CUyaa",
                        "type": "Entry",
                        "createdAt": "2023-05-18T03:23:50.744Z",
                        "updatedAt": "2023-05-24T22:55:23.250Z",
                        "environment": {
                          "sys": {
                            "id": "sandbox",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "publishedVersion": 6,
                        "revision": 2,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "country"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "name": "United States",
                        "isocode": "US",
                        "flag": {
                          "metadata": {
                            "tags": [],
                            "concepts": []
                          },
                          "sys": {
                            "space": {
                              "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                              }
                            },
                            "id": "3aYCbZJiL8aoEKRdhjOXyy",
                            "type": "Asset",
                            "createdAt": "2023-05-24T22:54:50.939Z",
                            "updatedAt": "2023-05-24T22:54:50.939Z",
                            "environment": {
                              "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                              }
                            },
                            "publishedVersion": 5,
                            "revision": 1,
                            "locale": "en-US"
                          },
                          "fields": {
                            "title": "usa flag",
                            "description": "USA Flag",
                            "file": {
                              "url": usaFlag,
                              "details": {
                                "size": 2487,
                                "image": {
                                  "width": 36,
                                  "height": 26
                                }
                              },
                              "fileName": "usa_flag.svg",
                              "contentType": "image/svg+xml"
                            }
                          }
                        },
                        "locales": [
                          "en-US"
                        ]
                      }
                    }
                  }
                },
                {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "3LzpM6ba6wGXMlxYkj0OfE",
                    "type": "Entry",
                    "createdAt": "2023-06-16T18:28:28.772Z",
                    "updatedAt": "2023-06-16T18:28:39.366Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 5,
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "bannerComponent"
                      }
                    },
                    "locale": "en-US"
                  },
                  // "fields": {
                  //   "title": "Return Goods Policy Banner Component - DE",
                  //   "headline": "Moderna Vaccine Product Return Policy",
                  //   "backgroundImage": "[Circular Reference]",
                  //   "country": {
                  //     "metadata": {
                  //       "tags": [],
                  //       "concepts": []
                  //     },
                  //     "sys": {
                  //       "space": {
                  //         "sys": {
                  //           "type": "Link",
                  //           "linkType": "Space",
                  //           "id": "n9bebhw263o0"
                  //         }
                  //       },
                  //       "id": "7DX7badGk41XRSy4znPNFI",
                  //       "type": "Entry",
                  //       "createdAt": "2023-05-18T03:24:01.186Z",
                  //       "updatedAt": "2023-05-24T23:04:52.125Z",
                  //       "environment": {
                  //         "sys": {
                  //           "id": "sandbox",
                  //           "type": "Link",
                  //           "linkType": "Environment"
                  //         }
                  //       },
                  //       "publishedVersion": 5,
                  //       "revision": 2,
                  //       "contentType": {
                  //         "sys": {
                  //           "type": "Link",
                  //           "linkType": "ContentType",
                  //           "id": "country"
                  //         }
                  //       },
                  //       "locale": "en-US"
                  //     },
                  //     "fields": {
                  //       "name": "Germany",
                  //       "isocode": "DE",
                  //       "flag": {
                  //         "metadata": {
                  //           "tags": [],
                  //           "concepts": []
                  //         },
                  //         "sys": {
                  //           "space": {
                  //             "sys": {
                  //               "type": "Link",
                  //               "linkType": "Space",
                  //               "id": "n9bebhw263o0"
                  //             }
                  //           },
                  //           "id": "1PJ5nPASFqJbHZkqrkOloj",
                  //           "type": "Asset",
                  //           "createdAt": "2023-05-24T23:04:44.544Z",
                  //           "updatedAt": "2023-05-24T23:04:44.544Z",
                  //           "environment": {
                  //             "sys": {
                  //               "id": "sandbox",
                  //               "type": "Link",
                  //               "linkType": "Environment"
                  //             }
                  //           },
                  //           "publishedVersion": 5,
                  //           "revision": 1,
                  //           "locale": "en-US"
                  //         },
                  //         "fields": {
                  //           "title": "Germany Flag",
                  //           "description": "Germany Flag",
                  //           "file": {
                  //             "url": "//images.ctfassets.net/n9bebhw263o0/1PJ5nPASFqJbHZkqrkOloj/586177dc5c2d17ea76a41a972053c188/de_flag.svg",
                  //             "details": {
                  //               "size": 1305,
                  //               "image": {
                  //                 "width": 36,
                  //                 "height": 26
                  //               }
                  //             },
                  //             "fileName": "de_flag.svg",
                  //             "contentType": "image/svg+xml"
                  //           }
                  //         }
                  //       },
                  //       "locales": [
                  //         "en-DE"
                  //       ]
                  //     }
                  //   }
                  // }
                },
                {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "5KqsjWl1JAA7AvePDZzaq5",
                    "type": "Entry",
                    "createdAt": "2022-12-14T23:00:13.065Z",
                    "updatedAt": "2024-07-19T13:17:52.682Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 166,
                    "revision": 14,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "richTextContentComponent"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Return Goods Rich Text Component - US",
                    "effectiveDateLabel": "Effective",
                    "effectiveDate": "2024-07-01",
                    "content": {
                      "nodeType": "document",
                      "data": {},
                      "content": [
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Returned Goods Policy and Procedures",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " \nModerna US, Inc. ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "This Return Goods Policy controls what Moderna products are eligible for return and sets forth procedures for return of those eligible products. This Policy may be amended by Moderna at any time in its sole discretion. Moderna will only accept returns subject to this Policy from parties that purchased product directly from Moderna or indirectly through an authorized distributor of record (ADR). The policy detailed below is for customers that have purchased directly from Moderna. For customers who purchased from an ADR, the Return Policy of the ADR should be followed for Seasonal and Non-Seasonal Returns. If your ADR’s policy instructs you to return directly to Moderna please follow the instructions in this policy.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Returnable Items:",
                              "marks": [
                                {
                                  "type": "bold"
                                },
                                {
                                  "type": "underline"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "unordered-list",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Products received by customer as damaged or received in error – Products received damaged or in error may be returned for full credit when reported within three (3) business days of receipt of product subject to the terms herein. Products should remain in the original carton for inspection, and products must be returned in accordance with all Return Authorization (RA) instructions. Please contact 1-866-MODERNA (663-3762) or email a request to ",
                                      "marks": [],
                                      "data": {}
                                    },
                                    {
                                      "nodeType": "hyperlink",
                                      "data": {
                                        "uri": "mailto:Commercialops@modernatx.com"
                                      },
                                      "content": [
                                        {
                                          "nodeType": "text",
                                          "value": "Commercialops@modernatx.com",
                                          "marks": [],
                                          "data": {}
                                        }
                                      ]
                                    },
                                    {
                                      "nodeType": "text",
                                      "value": " within three (3) business days to report product damaged or received in error.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Seasonal Product Returns.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                },
                                {
                                  "nodeType": "unordered-list",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "list-item",
                                      "data": {},
                                      "content": [
                                        {
                                          "nodeType": "paragraph",
                                          "data": {},
                                          "content": [
                                            {
                                              "nodeType": "text",
                                              "value": "“Seasonal Products” are defined as Products that are generally reformulated each season or each year to address new or changing virus/disease strains. Each reformulation generally requires approval from FDA and issuance of new NDC numbers. Seasonal Products remain eligible for sale until a new formulation is approved or as per direction and availability from Moderna.",
                                              "marks": [],
                                              "data": {}
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "nodeType": "list-item",
                                      "data": {},
                                      "content": [
                                        {
                                          "nodeType": "paragraph",
                                          "data": {},
                                          "content": [
                                            {
                                              "nodeType": "text",
                                              "value": "At the end of each season, a percentage of the total volume of Seasonal Product (currently, Covid-19 vaccine) purchased directly from Moderna may be returned for credit. The specific percentage will be defined in the customer contract. Returns in excess of the allowable total, within a single season, will be destroyed and only Federal Excise Tax (FET) will be credited where applicable.",
                                              "marks": [],
                                              "data": {}
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "nodeType": "list-item",
                                      "data": {},
                                      "content": [
                                        {
                                          "nodeType": "paragraph",
                                          "data": {},
                                          "content": [
                                            {
                                              "nodeType": "text",
                                              "value": "Return requests for seasonal returns of Moderna Seasonal Product must be received by Inmar during the Seasonal Returns Window. The Seasonal Returns Window will be communicated by Moderna, in its discretion, prior to its opening.",
                                              "marks": [],
                                              "data": {}
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Other Expired Products",
                                      "marks": [
                                        {
                                          "type": "bold"
                                        }
                                      ],
                                      "data": {}
                                    },
                                    {
                                      "nodeType": "text",
                                      "value": " that are not Seasonal Products as determined by Moderna may be returned within two months of expiry and up to 12 months after expiry.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Returns for partial cartons are accepted.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Products Ineligible for Returns:",
                              "marks": [
                                {
                                  "type": "bold"
                                },
                                {
                                  "type": "underline"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "All products, other than those listed above, shall be deemed ineligible for returned goods credit. Ineligible products cannot be returned to the customer and will be destroyed with no credit issued. Products that are ineligible for returned goods credit include, without limitation:",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "unordered-list",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Seasonal Product received after the defined seasonal return window closes.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Seasonal Product that exceeds the returns allowance/percentage specified in the customer contract.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Non-Seasonal Product returned prior to 2 months prior to expiry and more than 12 months after expiry.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Product obtained under EUA distribution from the United States Government.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Product returned without a Return Authorization (RA) as further explained below.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Product for which original proof of purchase cannot be verified.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Product returned with illegible or missing lot numbers, or expiration dates. No credit will be issued if the lot number or expiration date is missing, covered and/or unreadable on original container.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Repackaged product.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Product with an opened seal.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Product obtained at no cost and/or labeled as professional samples, clinical trial use, patient assistance program use or similar special labels.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Product sold on a non-returnable basis.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Product obtained illegally or re-imported from outside the United States.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Product that has been adulterated, misbranded, or counterfeit, as determined by Moderna at its sole reasonable discretion.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Distressed merchandise obtained through bankruptcy or sacrifice sale, going out-of- business sale, or other merchandise classified as “distressed merchandise.”",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Product damaged due to the negligence of the purchaser and/or customer.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Product that has not been properly stored according to guidelines provided by Moderna.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Product damaged by fire, water, or other acts of God.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Product returned by any indirect customer.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Procedure for Non-Seasonal or Other Product Returns",
                              "marks": [
                                {
                                  "type": "bold"
                                },
                                {
                                  "type": "underline"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Product returns require a RA issued through Moderna’s Customer Service department via phone number or email listed below. RAs expire thirty (30) calendar days from date issued.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Via phone:",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " 1-866-Moderna (663-3762)",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Via email:",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "mailto:Commercialops@modernatx.com"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "Commercialops@modernatx.com",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "unordered-list",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Customers who place orders directly with Moderna must submit an itemized list of products being returned, with the following information included for each product:",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                },
                                {
                                  "nodeType": "unordered-list",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "list-item",
                                      "data": {},
                                      "content": [
                                        {
                                          "nodeType": "paragraph",
                                          "data": {},
                                          "content": [
                                            {
                                              "nodeType": "text",
                                              "value": "Debit Memo number, product name, product quantity, unit price, serial number, GTIN, lot number, NDC number, expiration date, billing address, shipping address, contact name and phone/email, and RA number.",
                                              "marks": [],
                                              "data": {}
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Indirect requests for return (i.e., requests from a hospital and/or pharmacy) are not covered by this policy and instead must route through their ADR.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Ship returnable products, along with a copy of the Moderna RA and Debit Memo to:",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Shipping and Returned Goods Address:",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Inmar Rx Solutions\n3845 Grand Lakes Way\nSuite 125\nGrand Prairie, TX 75050",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "unordered-list",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "It is the shipper’s responsibility to securely package all returned products to prevent breakage during transit.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Product must be returned with shipping label and insurance unless such return is due to Moderna’s error (such as damaged product, mis-delivery, or discontinued/recalled product).",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Return Procedure for Eligible Returns:",
                              "marks": [
                                {
                                  "type": "bold"
                                },
                                {
                                  "type": "underline"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "unordered-list",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Expired product returns require a RA issued through Inmar. To request a RA from Inmar, please use one of the three options below. ",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                },
                                {
                                  "nodeType": "unordered-list",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "list-item",
                                      "data": {},
                                      "content": [
                                        {
                                          "nodeType": "paragraph",
                                          "data": {},
                                          "content": [
                                            {
                                              "nodeType": "text",
                                              "value": "Access the Inmar website at ",
                                              "marks": [],
                                              "data": {}
                                            },
                                            {
                                              "nodeType": "hyperlink",
                                              "data": {
                                                "uri": "https://hrm.reskureturns.com/landing"
                                              },
                                              "content": [
                                                {
                                                  "nodeType": "text",
                                                  "value": "https://hrm.reskureturns.com/landing",
                                                  "marks": [],
                                                  "data": {}
                                                }
                                              ]
                                            },
                                            {
                                              "nodeType": "text",
                                              "value": " and upload a PDF copy of your debit memo or Returns Request form",
                                              "marks": [],
                                              "data": {}
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "nodeType": "list-item",
                                      "data": {},
                                      "content": [
                                        {
                                          "nodeType": "paragraph",
                                          "data": {},
                                          "content": [
                                            {
                                              "nodeType": "text",
                                              "value": "E-mail document to ",
                                              "marks": [],
                                              "data": {}
                                            },
                                            {
                                              "nodeType": "hyperlink",
                                              "data": {
                                                "uri": "mailto:rarequest@inmar.com"
                                              },
                                              "content": [
                                                {
                                                  "nodeType": "text",
                                                  "value": "rarequest@inmar.com",
                                                  "marks": [],
                                                  "data": {}
                                                }
                                              ]
                                            },
                                            {
                                              "nodeType": "text",
                                              "value": "",
                                              "marks": [],
                                              "data": {}
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "nodeType": "list-item",
                                      "data": {},
                                      "content": [
                                        {
                                          "nodeType": "paragraph",
                                          "data": {},
                                          "content": [
                                            {
                                              "nodeType": "text",
                                              "value": "Fax document to Inmar at 817-868-5343.",
                                              "marks": [],
                                              "data": {}
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Customers must submit an itemized list of products being returned, with the following information included for each product, as shown on the invoice:",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                },
                                {
                                  "nodeType": "unordered-list",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "list-item",
                                      "data": {},
                                      "content": [
                                        {
                                          "nodeType": "paragraph",
                                          "data": {},
                                          "content": [
                                            {
                                              "nodeType": "text",
                                              "value": "Customer DEA and/or HIN# used to create account",
                                              "marks": [],
                                              "data": {}
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "nodeType": "list-item",
                                      "data": {},
                                      "content": [
                                        {
                                          "nodeType": "paragraph",
                                          "data": {},
                                          "content": [
                                            {
                                              "nodeType": "text",
                                              "value": "Customer Name",
                                              "marks": [],
                                              "data": {}
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "nodeType": "list-item",
                                      "data": {},
                                      "content": [
                                        {
                                          "nodeType": "paragraph",
                                          "data": {},
                                          "content": [
                                            {
                                              "nodeType": "text",
                                              "value": "Customer Shipping address as shown on invoice",
                                              "marks": [],
                                              "data": {}
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "nodeType": "list-item",
                                      "data": {},
                                      "content": [
                                        {
                                          "nodeType": "paragraph",
                                          "data": {},
                                          "content": [
                                            {
                                              "nodeType": "text",
                                              "value": "Source of Purchase (ADR name or Moderna)",
                                              "marks": [],
                                              "data": {}
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "nodeType": "list-item",
                                      "data": {},
                                      "content": [
                                        {
                                          "nodeType": "paragraph",
                                          "data": {},
                                          "content": [
                                            {
                                              "nodeType": "text",
                                              "value": "Product name, NDC number(s), lot number(s), expiration date(s)",
                                              "marks": [],
                                              "data": {}
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "nodeType": "list-item",
                                      "data": {},
                                      "content": [
                                        {
                                          "nodeType": "paragraph",
                                          "data": {},
                                          "content": [
                                            {
                                              "nodeType": "text",
                                              "value": "Product quantity",
                                              "marks": [],
                                              "data": {}
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "nodeType": "list-item",
                                      "data": {},
                                      "content": [
                                        {
                                          "nodeType": "paragraph",
                                          "data": {},
                                          "content": [
                                            {
                                              "nodeType": "text",
                                              "value": "Sale Unit price (Invoiced price)",
                                              "marks": [],
                                              "data": {}
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "nodeType": "list-item",
                                      "data": {},
                                      "content": [
                                        {
                                          "nodeType": "paragraph",
                                          "data": {},
                                          "content": [
                                            {
                                              "nodeType": "text",
                                              "value": "Contact name and phone/email",
                                              "marks": [],
                                              "data": {}
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "nodeType": "list-item",
                                      "data": {},
                                      "content": [
                                        {
                                          "nodeType": "paragraph",
                                          "data": {},
                                          "content": [
                                            {
                                              "nodeType": "text",
                                              "value": "Inmar will provide a box label to print when submitting your return request.",
                                              "marks": [],
                                              "data": {}
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "If you have any questions, please contact Inmar Pharmaceutical Services at 1-800-967-5952 option 3. Mon. – Fri. 7am – 5pm CT",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Include the completed RA box label with your return.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Send returns to:",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Inmar Rx Solutions\n3845 Grand Lakes Way\nSuite 125\nGrand Prairie, TX 75050",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "unordered-list",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "It is shipper’s responsibility to securely package all returned products to prevent breakage during transit.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "If multiple RAs are being returned within a single delivery to Inmar Pharmaceutical Services, ensure returned product with the associated RAs are distinctly separated (with appropriate labeling if needed) within the delivery. Failure to do so may result in inaccurate accounting of the return or a delay to the crediting process.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Returned products do not require cold chain shipping.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Transportation charges, including prepaid freight and insurance, are the responsibility of the customer. No fees of any kind will be approved for credit. Moderna is not responsible for return shipments lost in transit.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Additional Terms for Return Credit:",
                              "marks": [
                                {
                                  "type": "bold"
                                },
                                {
                                  "type": "underline"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "unordered-list",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Product must be in original retail trade packaging. Repackaged items will not be accepted for return or credited.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Credit for eligible and approved returns will be determined by Moderna. Such credit will be issued in credit memo form and will be applied to Customer’s current account balance.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Moderna reserves the right, prior to credit being issued, to verify the original proof of purchase to determine that product being returned was shipped from Moderna to Customer.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Credit for erroneous or damaged product will be issued upon receipt and processing of return of product. No deduction can be taken prior to that time.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Credit for Seasonal Returns will be issued at the end of each season. Credit will be limited to a contractually defined percentage of total vaccine product purchased directly from Moderna plus any applicable federal excise tax credit. Credit will be issued upon completion of the vaccine season and upon processing of returns. No deduction can be taken prior to that time.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Returned goods may not be exchanged for replacement merchandise.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "All returned product becomes the property of Moderna. All items returned without an RA, or not in compliance with this Policy, may be accepted but with no credit issued.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Returns from third-party processors acting on behalf of customers may be accepted provided that the customer receives approval from Moderna, and the third-party processor complies with all aspects of this Returned Goods Policy. Moderna is not responsible for fees incurred by third-party processor.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "All products returned are subject to final review and evaluation by Moderna.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Any questions regarding Moderna’s Returned Goods Policy can be addressed by Moderna’s Customer Care Team at 1-866-Moderna (663-3762).",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Reservation of Rights",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Moderna reserves the right to modify and make exceptions to this policy and to its implementation at any time, without notice, for any reason, including due to business necessity or changes in applicable laws and regulations.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        }
                      ]
                    },
                    "backToTopButtonLabel": "Back To Top",
                    "printButtonLabel": "Print",
                    "country": "[Circular Reference]"
                  }
                },
                {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "5FFA0liz6Apt9Uz8LsSWzy",
                    "type": "Entry",
                    "createdAt": "2023-05-24T19:13:43.878Z",
                    "updatedAt": "2023-06-16T20:38:06.226Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 18,
                    "revision": 6,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "richTextContentComponent"
                      }
                    },
                    "locale": "en-US"
                  },
                  // "fields": {
                  //   "title": "Return Goods Rich Text Component - DE",
                  //   "effectiveDateLabel": "Effective",
                  //   "effectiveDate": "2023-01-07",
                  //   "content": {
                  //     "nodeType": "document",
                  //     "data": {},
                  //     "content": [
                  //       {
                  //         "nodeType": "paragraph",
                  //         "data": {},
                  //         "content": [
                  //           {
                  //             "nodeType": "text",
                  //             "value": "Our Return Policy",
                  //             "marks": [
                  //               {
                  //                 "type": "bold"
                  //               }
                  //             ],
                  //             "data": {}
                  //           },
                  //           {
                  //             "nodeType": "text",
                  //             "value": "\n",
                  //             "marks": [],
                  //             "data": {}
                  //           }
                  //         ]
                  //       },
                  //       {
                  //         "nodeType": "paragraph",
                  //         "data": {},
                  //         "content": [
                  //           {
                  //             "nodeType": "text",
                  //             "value": "\nReturn policies have not yet been decided on and will be later displayed here. Please remember that by now this is a non binding reservation which will be converted to a binding reservation only with your active approval at a later point in time.",
                  //             "marks": [],
                  //             "data": {}
                  //           }
                  //         ]
                  //       },
                  //       {
                  //         "nodeType": "paragraph",
                  //         "data": {},
                  //         "content": [
                  //           {
                  //             "nodeType": "text",
                  //             "value": "",
                  //             "marks": [],
                  //             "data": {}
                  //           }
                  //         ]
                  //       },
                  //       {
                  //         "nodeType": "paragraph",
                  //         "data": {},
                  //         "content": [
                  //           {
                  //             "nodeType": "text",
                  //             "value": "\n\n\n",
                  //             "marks": [],
                  //             "data": {}
                  //           }
                  //         ]
                  //       }
                  //     ]
                  //   },
                  //   "backToTopButtonLabel": "Back To Top",
                  //   "printButtonLabel": "Print",
                  //   "country": "[Circular Reference]"
                  // }
                }
              ]
            }
          }
        },
        "sys": {
          "id": "6nT2JOBfWhTcZ1Pwxzp5rn",
          "type": "Entry"
        }
      }
    ],
    "includes": {
      "Entry": [
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]"
      ],
      "Asset": [
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]"
      ]
    }
}